import sdl from '@jds/react-generated-sdl/JDSSpinner';
import type { JDSSpinnerProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic, SpinnerProps } from '../logic';

const Component = (props: SpinnerProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    labelPosition = 'right',
    size = 'medium',
    kind = 'normal',
    isOverlay = false,
    ariaLabel = 'Loading',
    ariaLive = 'polite',
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { labelPosition, size, kind, isOverlay, ariaLabel, ariaLive, ...rest },
    'JDSSpinner',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const Spinner = withLogic(Component) as React.FC<SpinnerProps> & {
  slotName?: string;
};

Spinner.displayName = 'Spinner';
Spinner.slotName = 'jds_spinner';

export { Spinner, type JDSSpinnerProps };
